import React, { useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

//meridian
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Popover from '@amzn/meridian/popover';
import Row from '@amzn/meridian/row';
import menuMeatballIcon from '@amzn/meridian-tokens/base/icon/menu-meatball';

const ContextMenu = ({
  id,
  position,
  menuItems,
  clickstreamTags: contextMenuClickstreamTags,
}) => {
  const buttonRef = useRef();
  const [open, setOpen] = useState(false);
  const onContextMenuClickButton = useCallback(() => setOpen(true), []);

  const [openModals, setOpenModals] = useState(menuItems.map(() => false));

  const onPopoverClose = useCallback(() => setOpen(false), []);

  const onModalVisibilityStateChanged = (modalIndex, isVisible) => {
    const newOpenModalsState = [...openModals];
    newOpenModalsState[modalIndex] = isVisible;
    setOpenModals(newOpenModalsState);
  };

  const contextMenuContentID = 'context-menu-content';
  return (
    <div data-testid={contextMenuContentID} data-cy={contextMenuContentID}>
      {menuItems.map((menuItem, modalIndex) => {
        return (
          <React.Fragment key={modalIndex}>
            {menuItem.modal &&
              openModals[modalIndex] &&
              React.cloneElement(menuItem.modal, {
                open: openModals[modalIndex],
                onModalClose: () => {
                  onModalVisibilityStateChanged(modalIndex, false);
                  menuItem.onModalClose && menuItem.onModalClose.call();
                },
                onModalConfirm: () => {
                  onModalVisibilityStateChanged(modalIndex, false);
                  menuItem.onModalConfirm && menuItem.onModalConfirm.call();
                },
              })}
          </React.Fragment>
        );
      })}

      <Row alignmentHorizontal='justify'>
        <Button
          id={id}
          type='icon'
          className='context-menu-button'
          data-cy={`${id}-context-menu-button`}
          onClick={onContextMenuClickButton}
          ref={buttonRef}
          data-testid={`${id}-popover-button`}
          {...contextMenuClickstreamTags}
        >
          <Icon tokens={menuMeatballIcon} />
        </Button>
        <Popover
          id={`${id}-popover`}
          anchorNode={buttonRef.current}
          open={open}
          onClose={onPopoverClose}
          position={position}
          shrinkToFit={true}
        >
          <Column data-testid={`${id}-popover-content`}>
            {menuItems.map((menuItem, modalIndex) => {
              const buttonId = menuItem.id || `context-btn-div-${modalIndex}`;
              return (
                <Button
                  className={`context-menu-btn-${menuItem.type}`}
                  key={modalIndex}
                  type={menuItem.type || 'tertiary'}
                  {...menuItem.clickstreamTags}
                  onClick={() =>
                    menuItem.callbackFunc
                      ? menuItem.callbackFunc.call()
                      : onModalVisibilityStateChanged(modalIndex, true)
                  }
                  id={`context-menu-button-${modalIndex}`}
                  data-testid={`context-menu-button-${modalIndex}`}
                  data-cy={`context-menu-button-${modalIndex}`}
                >
                  <div id={buttonId} data-cy={buttonId} data-testid={buttonId}>
                    {menuItem.label}
                  </div>
                </Button>
              );
            })}
          </Column>
        </Popover>
      </Row>
    </div>
  );
};

ContextMenu.propTypes = {
  id: PropTypes.string,
  alias: PropTypes.string,
  position: PropTypes.string,
  clickstreamTags: PropTypes.object,
  menuItems: PropTypes.arrayOf(PropTypes.object),
};
export default ContextMenu;
